// Utils
import { $qs, $qsa } from "./utils/QuerySelector";

//JS
import { magnificPopupIframe, magnificPopupInline, magnificPopupSingleImage, magnificPopupGalleryImage, magnificPopupSlider } from './js/popups'
import { mainMenu, quicklinksMenu, mobileMenu } from './js/menu'
import { statsSlider } from './js/sliders'
import { faqToggles, policyToggles } from './js/toggles'
import { fixedMenuAdmissions } from './js/admissions'
import { adaptiveVideo } from './js/adaptiveVideo'

// Animations
import twkScroll from "./animations/twkScroll";
import homeAnimation from "./animations/homeAnimations";
import headerAnimations from "./animations/headerAnimation";
import videoCursor from "./animations/customCursor";
//import lottieAnimation from "./animations/lottieAnimations";

// Components
import accordion from "./blocks/accordion";
import imageSlider from "./blocks/image-slider";
import imageCarousel from "./blocks/image-carousel";
import quoteSlider from "./blocks/quote-slider";
import quoteSliderGrey from "./blocks/quote-slider-grey";
import logoSlider from "./blocks/destination-slider";
import newsSlider from "./blocks/homepage-news-block";
import eventSlider from "./blocks/homepage-events-block";
import mobileSlider from "./blocks/images";
import instagramFeedAnimation from "./blocks/instagram-feed";
import instagramAlumniFeedAnimation from "./blocks/instagram-feed-alumni";
import homeImageSliderAnimation from "./blocks/home-image-slider";
import lineAnimation from "./blocks/line-animation";

// Scripts;
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import headerAnimation from "./animations/headerAnimation";
gsap.registerPlugin(ScrollTrigger);


// Packages
//import 'slick-carousel';
//import 'magnific-popup';

function init() {
  twkScroll();
  
  if ($qs("body.page-template-tpl-home")) {
    homeAnimation();
    newsSlider();
    eventSlider();
    homeImageSliderAnimation();
    //homeAnimation();
  }
  headerAnimations();
  videoCursor();
  adaptiveVideo();
  accordion();
  instagramFeedAnimation();
  instagramAlumniFeedAnimation();
  
  // Menu
  mainMenu()
  mobileMenu()
  quicklinksMenu()
  
  // Popups
  magnificPopupIframe()
  magnificPopupInline()
  magnificPopupSingleImage()
  magnificPopupGalleryImage()
  magnificPopupSlider()
  
  // Sliders
  statsSlider()
  logoSlider();
  imageSlider();
  imageCarousel();
  quoteSlider();
  quoteSliderGrey();
  mobileSlider();

  faqToggles()
  policyToggles()
  fixedMenuAdmissions()
  lineAnimation()
  
  
  //lottieAnimation();
}
init();


jQuery(document).ready(function ($) {
  
  consoleMessage: {
    console.log(
      "%cCreated by %cTWK%cwww.thewebkitchen.co.uk",
      "background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;",
      "background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;",
      "background: #FFFFFF; padding: 5px 10px;"
    );
  }


  $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
    modalPopupSlider();
  });


  anchorlinks: {
    $(document).on("click", ".scroll-to", function (event) {
      event.preventDefault();

      $("html, body").animate(
        {
          scrollTop: $($.attr(this, "href")).offset().top - 150,
        },
        500
      );
    });
    $(document).on("click", ".scroll-to--admissions", function (event) {
      event.preventDefault();

      $("html, body").animate(
        {
          scrollTop: $($.attr(this, "href")).offset().top - 250,
        },
        500
      );
    });
  }

  externallinks: {
    $('a[href^="mailto:"]').each(function () {
      $(this).addClass("email-link");
    });

    $('a:not(.email-link):not([class^="magnific-"])').each(function () {
      var a = new RegExp("/" + window.location.host + "/");

      if (!a.test(this.href)) {
        $(this).click(function (event) {
          event.preventDefault();
          window.open(this.href, "_blank");
        });
      }
    });
    pdfs: {
      // Open PDFs in new window
      $(function () {
        $('a[href$=".pdf"]').prop("target", "_blank");
      });
    }
  }


  tables: {
    $('.tablepress').wrap('<div class="tablewrapper"></div>');
  }


  embedForms: {
    // Enquiry form page
    if ( $('body').hasClass('page-id-52') ) {
      setTimeout(function() {
        if ( $('.admissionsEnquiry').length ) {
          //console.log('enquiry form loaded');
        } else {
          //console.log('enquiry form missing');
          sendFormWarning('52');
        }
       }, 5100);
    }
    if ( $('body').hasClass('page-id-53') ) {
      setTimeout(function() {
        if ( $('.admissionsEnquiry').length ) {
          //console.log('enquiry form loaded');
        } else {
          //console.log('enquiry form missing');
          sendFormWarning('53');
        }
       }, 5100);
    }


    function sendFormWarning(page) {
      console.log('ajax triggered');
      $.ajax({
        type: 'POST',
        url: php_vars.ajaxUrl,
        dataType: 'html',
        data: {
          action: 'send_form_warnings',
          mode: 'POST',
          status: 'fail',
          page_id: page,
        },
        success: function success(html) {

          console.log('missing form, email sent'); 

        },
        error: function error(_error) {
          console.error(_error);
          console.log('test');
        }
      });
    }

  }


});
